import { isPlatformInternalAttr } from '@/runtime/platformInternalAttrs'

export interface ListFieldDef {
  name: string
  synonym?: string
  attr_type: string
}

export type ListViewKind = 'list' | 'kanban' | 'tree' | 'calendar'

const KANBAN_TYPES = new Set(['ref', 'enum_ref', 'boolean', 'string'])
const CALENDAR_TYPES = new Set(['date', 'datetime'])

const eligible = (types: Set<string>) => (f: ListFieldDef) =>
  types.has((f.attr_type || '').toLowerCase()) && !isPlatformInternalAttr(f.name)

export function kanbanCandidates(fields: ListFieldDef[]): ListFieldDef[] {
  return fields.filter(eligible(KANBAN_TYPES))
}

/** Group-by offers the same discrete fields as kanban columns. */
export const groupByCandidates = kanbanCandidates

/** @deprecated Calendar view removed from availableViews — kept for legacy prefs/typecheck. */
export function calendarCandidates(fields: ListFieldDef[]): ListFieldDef[] {
  return fields.filter(eligible(CALENDAR_TYPES))
}

export function availableViews(
  fields: ListFieldDef[],
  opts?: { hierarchical?: boolean },
): ListViewKind[] {
  const views: ListViewKind[] = ['list']
  if (kanbanCandidates(fields).length > 0) views.push('kanban')
  if (opts?.hierarchical) views.push('tree')
  return views
}
